import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import logo from "../../media/logo.png";
import moment from "moment";
import settings from "../../settings";
import PropTypes from "prop-types";

class LoadingSpinner extends Component {
  constructor(props) {
    super(props);
  }

  _animation = () => {
    if (this.props?.animation) return this.props.animation;
    else return "border";
  };

  _variant = () => {
    if (this.props?.variant) return this.props.variant;
    else return "primary";
  };

  _size = () => {
    if (this.props?.size) return this.props.size;
    else return "lg";
  };

  _isScreenLoader = () => {
    return this.props.isScreenLoader;
  };

  render() {
    if(this._isScreenLoader()) {
      // This is a normal screen loader
      return (
        <span className={`d-flex justify-content-center ${this.props?.className}`}>
          <Spinner
            animation={this._animation()}
            variant={this._variant()}
            size={this._size()}
            role="status"
            className={`${this.props?.classNameSpinner}`}
            style={this.props?.style}
          >
            <span className="sr-only">Loading...</span>
          </Spinner>
        </span>
      );
    }
    else {
      // This is to allow loaders inside a button
      return (
        <Spinner
          animation={this._animation()}
          variant={this._variant()}
          size={this._size()}
          role="status"
          className={`${this.props?.classNameSpinner}`}
          style={this.props?.style}
        >
          <span className="sr-only">Loading...</span>
        </Spinner>
      );
    }
  }
}

LoadingSpinner.propTypes = {
  animation: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  isScreenLoader: PropTypes.bool
};

LoadingSpinner.defaultProps = {
  isScreenLoader: true
}

export default LoadingSpinner;
